const config = {
  Auth: {
    identityPoolId: "eu-west-1:99ca5242-210c-42b3-98d6-a8c1ea5cce34",
    region: "eu-west-1",
    identityPoolRegion: "eu-west-1",
    userPoolId: "eu-west-1_vUo4vnVbc",
    userPoolWebClientId: "20aouqj48qqa9umjo8a2o9a0ah",
    mandatorySignIn: false,
    authenticationFlowType: "USER_SRP_AUTH",
  },
};
export default config;
